import React from "react";
import { Modal } from "./ui";

/** ⌘K: «Результаты поиска» — `<strong>перевозчик</strong> · машина` per match. */
export function TruckResultsDialog({ matches, onClose }) {
  return (
    <Modal title="Результаты поиска" onClose={onClose}>
      {matches.length ? (
        matches.map((t) => (
          <p key={`${t.driver_id}-${t.vehicle_id}`}>
            <strong>{t.driver_name}</strong> · {t.mark || "—"}
          </p>
        ))
      ) : (
        <p>Совпадений нет.</p>
      )}
    </Modal>
  );
}
